import React from 'react';
import { Card, TextContainer, Button } from '@shopify/polaris';

export default function CommunityPage() {
  return (
    <Card sectioned>
      <TextContainer>
        <h2>🧑‍🤝‍🧑 Guide & Community</h2>
        <p>
          Welcome to the community! Join us to get help, share ideas, and connect with other users.
        </p>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 16 }}>
          <Button url="https://discord.gg/yourlink" external>Join Discord</Button>
          <Button url="https://slack.com/yourlink" external>Join Slack</Button>
          <Button url="mailto:support@yourapp.com" external>Contact Support</Button>
        </div>
      </TextContainer>
      <Card title="Quick Start Guide" sectioned>
        <ul>
          <li>Start by connecting your store.</li>
          <li>Try your first query from the dashboard.</li>
          <li>Check the FAQ for common questions.</li>
        </ul>
      </Card>
      <Card title="FAQ & Best Practices" sectioned>
        <ul>
          <li>How to join the community? Use the links above.</li>
          <li>How to contact support? Click the support button.</li>
          <li>Is the app multilingual? Yes, it adapts to your Shopify admin language.</li>
        </ul>
      </Card>
    </Card>
  );
} 